var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form" }, [
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("input-text", {
          ref: "owhusNmad",
          attrs: {
            id: "owhusNmad",
            value: _vm.data.owhusNmad,
            "label-i18n": "MPRS-01-01-04-06",
            placeholder: "MPRS-01-01-04-06",
            maxlength: 10,
            "err-msg-param": { filed: _vm.$t("MPRS-01-01-04-06"), max: 10 },
            toLowerCase: ""
          },
          on: {
            "update:value": function($event) {
              return _vm.$set(_vm.data, "owhusNmad", $event)
            }
          }
        })
      ],
      1
    ),
    _c("div", { staticClass: "form-row" }, [
      _c(
        "div",
        { staticClass: "item-tit" },
        [
          _vm._v(" " + _vm._s(/*상세 주소*/ _vm.$t("MPRS-01-01-04-07")) + " "),
          _c("required")
        ],
        1
      ),
      _c("div", { staticClass: "item-desc" }, [
        _c("div", { staticClass: "form-text-field" }, [
          _c(
            "div",
            { staticClass: "input-text-field address" },
            [
              _c("input-text", {
                ref: "owhusAddr1",
                attrs: {
                  id: "owhusAddr1",
                  value: _vm.data.owhusAddr1,
                  placeholder: "MPRS-01-01-04-07",
                  maxlength: 66,
                  "err-msg-param": {
                    filed: _vm.$t("MPRS-01-01-04-07"),
                    max: 66
                  },
                  required:
                    _vm.$config.SITECODE_OGCBD +
                    "|" +
                    _vm.$config.SITECODE_OGHCM +
                    "|" +
                    _vm.$config.SITECODE_OGMMR,
                  toLowerCase: ""
                },
                on: {
                  "update:value": function($event) {
                    return _vm.$set(_vm.data, "owhusAddr1", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "input-text-field" },
            [
              _c("input-text", {
                ref: "owhusAddr2",
                attrs: {
                  id: "owhusAddr2",
                  value: _vm.data.owhusAddr2,
                  maxlength: 66,
                  "err-msg-param": {
                    filed: _vm.$t("MPRS-01-01-04-07"),
                    max: 66
                  },
                  toLowerCase: ""
                },
                on: {
                  "update:value": function($event) {
                    return _vm.$set(_vm.data, "owhusAddr2", $event)
                  }
                }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("input-text", {
          ref: "owhusAddr3",
          attrs: {
            id: "owhusAddr3",
            value: _vm.data.owhusAddr3,
            "label-i18n": "MPRS-01-01-04-08",
            placeholder: "MPRS-01-01-04-08",
            toLowerCase: ""
          },
          on: {
            "update:value": function($event) {
              return _vm.$set(_vm.data, "owhusAddr3", $event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }